import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useFetchPeCompanyOrderDetailQuery } from 'rtkQuery/sharespro/queries/peService';

import PeCompanyDataView from 'presentation/components/modules/pe/shared/detail/PeCompanyDataView';

const PeCompanyOrderDetailPage: FC = () => {
  const { id } = useParams();
  const { isFetching, data, refetch, error } =
    useFetchPeCompanyOrderDetailQuery({
      id: +(id as string),
    });

  return (
    <PeCompanyDataView
    assetId={+(id as string)}
      data={data?.company}
      refetch={() => {
        refetch();
      }}
      isFetching={isFetching}
      error={error}
    />
  );
};

export default PeCompanyOrderDetailPage;
